module.exports = __webpack_public_path__ + "img/border-top-supporter-3.b014b13.svg";